"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseUpstreamDatabasesQueryGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var queries_1 = require("../../../gen-src/queries");
var DatabaseRowDataFunctions_1 = require("../database/functions/DatabaseRowDataFunctions");
var DatabasesDisplayGrid_1 = require("../sharedDisplayGrid/DatabasesDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.databases && resultData.databases[0] &&
        resultData.databases[0].upstreamDatabasesConnection;
}
function selectConnectionListResultForFilteredQuery(resultData) {
    return resultData && resultData.tables && resultData.tables[0] &&
        resultData.tables[0].upstreamDatabasesConnection;
}
function selectMaxCountsResult(resultData) {
    return resultData && resultData.databases && resultData.databases[0];
}
function selectMaxCountsResultForFilteredQuery(resultData) {
    return resultData && resultData.tables && resultData.tables[0];
}
function getRowDataForDatabase(database, resultData) {
    return (0, DatabaseRowDataFunctions_1.getRowDataWithMaxCountsForDatabase)(database, selectMaxCountsResult(resultData));
}
function getRowDataForDatabaseForFilteredQuery(database, resultData) {
    return (0, DatabaseRowDataFunctions_1.getRowDataWithMaxCountsForDatabase)(database, selectMaxCountsResultForFilteredQuery(resultData));
}
function DatabaseUpstreamDatabasesQueryGrid(props) {
    var publishedConnectionsLineageEnabled = react_1.default.useContext(data_catalog_shared_1.FeatureFlagsContext).publishedConnectionsLineageEnabled;
    var emptyGridMessage = Localize_1.Messages.EmptyUpstreamDatabasesLineageGridMessage();
    var emptyFilteredGridMessage = Localize_1.Messages.EmptyUpstreamFilteredDatabasesLineageGridMessage();
    return props.filteredTableId ? (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: queries_1.DatabaseUpstreamDatabasesFilteredByTableDocument, partialQueryVariables: { tableId: props.filteredTableId, orderBy: props.orderBy, publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled }, selectConnectionListResult: selectConnectionListResultForFilteredQuery, mapResultNode: getRowDataForDatabaseForFilteredQuery }, function (_a) {
        var rowStore = _a.rowStore;
        return react_1.default.createElement(DatabasesDisplayGrid_1.DatabasesDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyFilteredGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder });
    })) : (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: queries_1.DatabaseUpstreamDatabasesDocument, partialQueryVariables: { databaseId: props.databaseId, orderBy: props.orderBy, publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled }, selectConnectionListResult: selectConnectionListResult, mapResultNode: getRowDataForDatabase }, function (_a) {
        var rowStore = _a.rowStore;
        return react_1.default.createElement(DatabasesDisplayGrid_1.DatabasesDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder });
    }));
}
exports.DatabaseUpstreamDatabasesQueryGrid = DatabaseUpstreamDatabasesQueryGrid;
//# sourceMappingURL=DatabaseUpstreamDatabasesQueryGrid.js.map